import React, { useEffect } from "react";
import {useParams } from 'react-router-dom';
import { Col, Container, Row } from "react-bootstrap";

import './Blog.css'
import ComingSoon from '../components/ComingSoon'
import blogDetailInfo from '../assets/data/blogData'; // Import the data




  const Contents = ({ blog }) => {
	const { mText, img, headline } = blog;
	return (
	  <div className="ezy__blogdetails4-contents">
		<p dir="rtl" > {headline} </p>

		<img
		  src={img}
		  alt=""
		  className="ezy__blogdetails4-banner img-fluid"
		/>
		<pre className="opacity-100 mt-5" style={{ whiteSpace: 'pre-wrap'}}>
		<p dir="rtl" style={{ textAlign: 'justify' }} > {mText} </p>
		</pre>
	  </div>
	);
  };

  const SideBar = ({ blog }) => {
	const { aboutusText } = blog;
	return (
	  <div>
		<div>
		  <h4 className="ezy__blogdetails4-title" dir="rtl" >در مورد ما</h4>
		  <p className="opacity-75" dir="rtl">{aboutusText}</p>
		</div>
	  </div>
	);
  };


  const BlogDetails1 = () => {
	const { id } = useParams();
	const blog = blogDetailInfo.find(blog => blog.id === parseInt(id));
	
	// Scroll to top on component mount
	useEffect(() => {
	window.scrollTo({
		top: 20,
		left: 0,
		behavior: "auto",
		});
	}, []);

	if (!blog) {
	  return <ComingSoon />;
	}
  
	return (
	  <section className="ezy__blogdetails4 light">
		<Container>
		  <Row>
			<Col xs={12} md={8} lg={9} className="order-1 order-md-2">
			  <Contents blog={blog} />
			</Col>
			<Col xs={12} md={4} lg={3} className="order-2 order-md-1">
			  <SideBar blog={blog} />
			</Col>
		  </Row>
		</Container>
	  </section>
	);
  };


export default BlogDetails1;